// Helpers to preserve the original path, query string and hash across the
// login redirect flow.
//
// Case A (passthrough): user hits /login directly carrying its own query/hash
//   /login?mcp_connect=X#mcp_connect=X  ->  /dashboard/home?mcp_connect=X#mcp_connect=X
// Case B (explicit): a guard/401 bounced the user to login with a redirect param
//   /login?redirect=/dashboard/tracking  ->  /dashboard/tracking

const DEFAULT_TARGET = '/dashboard/home';

// Only the leading path is validated; any query string and hash are kept verbatim.
// Rejects absolute URLs and protocol-relative / backslash tricks (open redirect).
export const safeRelativePath = (p) => {
    if (typeof p !== 'string' || p.length === 0) return null;
    if (!p.startsWith('/')) return null;
    if (p.startsWith('//') || p.startsWith('/\\')) return null;
    return p;
};

// Build the URL to send an unauthenticated user to.
export const buildLoginUrl = (target) => {
    const safe = safeRelativePath(target);
    if (!safe || safe.startsWith('/login')) return '/login';
    return `/login?redirect=${encodeURIComponent(safe)}`;
};

// Full relative target for the current browser location (path + search + hash).
export const currentLocationTarget = () =>
    window.location.pathname + window.location.search + window.location.hash;

// Where to go after a successful login.
export const resolvePostLoginTarget = () => {
    const sp = new URLSearchParams(window.location.search);
    const redirect = sp.get('redirect');
    if (redirect) {
        // Case B: redirect value may itself carry ?... and #...
        return safeRelativePath(redirect) || DEFAULT_TARGET;
    }
    // Case A: forward login's own query (minus redirect) and hash onto the default target.
    sp.delete('redirect');
    const qs = sp.toString();
    return `${DEFAULT_TARGET}${qs ? `?${qs}` : ''}${window.location.hash}`;
};
